module.exports = __webpack_public_path__ + "img/be4b99b.jpg";